import debug from 'debug';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';
import { search as logService } from 'Minetilbud/Shared/Components/LogService/Search';
import Data from '../data/data';
import LinksPopover from '../render/links-popover';
import DataLayer from '../utils/data-layer';

const log = debug('Search:Events:Links');

class Links {
	constructor(element) {
		this.element = element;

		this.linkEvent = this.linkHandler.bind(this);

		this.initialize();
	}

	/**
	 * @param {Object} product
	 */
	catalogLinkHandler(product) {
		DataLayer.searchClick({ product, searchTerm: queryString.Get('qw') });
		logService.Navigate();
		window.location.href = product.advertUrl;
	}

	eventListeners() {
		this.element.addEventListener('click', this.linkEvent, false);
	}

	/**
	 * @param {Object} product
	 */
	feedLinkHandler(product) {
		DataLayer.searchClick({ product, searchTerm: queryString.Get('qw') });
		logService.Navigate('feed');
		window.location.href = product.advertUrl;
	}

	initialize() {
		this.eventListeners();
	}

	/**
	 * @param {Event} event
	 */
	linkHandler(event) {
		try {
			const buttonElement = event.target.closest('[data-event]');
			if (buttonElement === null) throw 'buttonElement is null';
	
			event.preventDefault();
			
			const id = buttonElement.getAttribute('data-id');
			const product = Data.all.filter(product => product.id === id);
	
			if (product.length === 0) throw `there is no product with id: ${id}`;

			switch (buttonElement.getAttribute('data-event')) {
				case 'catalog-link':
					this.catalogLinkHandler(product[0]);
					break;
				case 'feed-link':
					this.feedLinkHandler(product[0]);
					break;
				case 'online-link':
					this.onlineLinkHandler(product[0]);
					break;
				case 'online-links':
					this.onlineLinksHandler({ buttonEvent: event, product: product[0] });
					break;
				default:
					throw 'link has no action';
			}
		} catch(error) {
			log('linkHandler()', error);
		}
	}

	/**
	 * @param {Object} product
	 */
	onlineLinkHandler(product) {
		DataLayer.searchClick({ product, searchTerm: queryString.Get('qw') });
		DataLayer.shoppingClick({ product, searchTerm: queryString.Get('qw'), url: product.links[0].url });

		window.open(product.links[0].url, '_blank');
	}

	/**
	 * @param {Object} options
	 * @param {Event} options.buttonEvent
	 * @param {Object} options.product
	 */
	onlineLinksHandler({ buttonEvent, product }) {
		if (product.links.length === 1) {
			this.onlineLinkHandler(product);
			return;
		}

		DataLayer.searchClick({ product, searchTerm: queryString.Get('qw') });
		const linksPopover = new LinksPopover({ customerName: product.customerName, links: product.links, linksEvent: buttonEvent});
	}
}

export default Links;
